import React from 'react';
import useAsync from 'hooks/globals/useAsync';
import InlineButton from './InlineButton';
import type IIInlineButtonWithStatus from './shared/types/inlineButtonWithStatus';

const InlineButtonWithStatus = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, IIInlineButtonWithStatus>(
    (
        {
            onClick: asyncFunction,
            onIdle,
            onPending,
            onSuccess,
            onError,
            status: explicitStatus,
            children,
            ...restProps
        },
        ref
    ) => {
        const { execute, status } = useAsync(asyncFunction, false);

        const statuses = {
            idle: onIdle,
            pending: onPending || onIdle,
            success: onSuccess || onIdle,
            error: onError || onIdle
        };

        return (
            <InlineButton ref={ref} onClick={execute} {...restProps}>
                {statuses[explicitStatus || status]} {children}
            </InlineButton>
        );
    }
);

export default InlineButtonWithStatus;
